import type { TableColumnDefinition } from "$components/table";
import type { IntlShape } from "react-intl";

export const getViewColumns = (
  formatMessage: IntlShape["formatMessage"],
): TableColumnDefinition[] => [
  {
    field: "date",
    headerName: formatMessage({
      defaultMessage: "Date",
      id: "nigeriaDailyOutpatientRegister.header.date",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "name",
    headerName: formatMessage({
      defaultMessage: "Name",
      id: "nigeriaDailyOutpatientRegister.header.name",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 150,
  },
  {
    field: "cardNumber",
    headerName: formatMessage({
      defaultMessage: "Card number",
      id: "nigeriaDailyOutpatientRegister.header.cardNumber",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 130,
  },
  {
    field: "gender",
    headerName: formatMessage({
      defaultMessage: "Gender",
      id: "nigeriaDailyOutpatientRegister.header.gender",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 65,
  },
  {
    field: "age",
    headerName: formatMessage({
      defaultMessage: "Age",
      id: "nigeriaDailyOutpatientRegister.header.age",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 60,
  },
  {
    field: "isPregnant",
    headerName: formatMessage({
      defaultMessage: "Is pregnant?",
      id: "nigeriaDailyOutpatientRegister.header.isPregnant",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 85,
  },
  {
    field: "attendanceType",
    headerName: formatMessage({
      defaultMessage: "Attendance Type",
      id: "nigeriaDailyOutpatientRegister.header.attendanceType",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 95,
  },
  {
    field: "weight",
    headerName: formatMessage({
      defaultMessage: "Weight",
      id: "nigeriaDailyOutpatientRegister.header.weight",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "height",
    headerName: formatMessage({
      defaultMessage: "Height",
      id: "nigeriaDailyOutpatientRegister.header.height",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 80,
  },
  {
    field: "BMI",
    headerName: formatMessage({
      defaultMessage: "BMI",
      id: "nigeriaDailyOutpatientRegister.header.BMI",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 70,
  },
  {
    field: "presentingComplaint",
    headerName: formatMessage({
      defaultMessage: "Presenting complaint",
      id: "nigeriaDailyOutpatientRegister.header.presentingComplaint",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "investigationsCompleted",
    headerName: formatMessage({
      defaultMessage: "Investigations completed",
      id: "nigeriaDailyOutpatientRegister.header.investigationsCompleted",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 150,
  },
  {
    field: "diagnosis",
    headerName: formatMessage({
      defaultMessage: "Diagnosis",
      id: "nigeriaDailyOutpatientRegister.header.diagnosis",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 150,
  },
  {
    field: "drugsGiven",
    headerName: formatMessage({
      defaultMessage: "Drugs given",
      id: "nigeriaDailyOutpatientRegister.header.drugsGiven",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 150,
  },
  {
    field: "outcome",
    headerName: formatMessage({
      defaultMessage: "Outcome of visit",
      id: "nigeriaDailyOutpatientRegister.header.outcome",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "malariaDiagnosis",
    headerName: formatMessage({
      defaultMessage: "Malaria diagnosis",
      id: "nigeriaDailyOutpatientRegister.header.malariaDiagnosis",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 115,
  },
  {
    field: "actGiven",
    headerName: formatMessage({
      defaultMessage: "ACT given",
      id: "nigeriaDailyOutpatientRegister.header.actGiven",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 60,
  },
  {
    field: "otherAntimalarialGiven",
    headerName: formatMessage({
      defaultMessage: "Other antimalarial given",
      id: "nigeriaDailyOutpatientRegister.header.otherAntimalarialGiven",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 105,
  },
  {
    field: "severeMalaria",
    headerName: formatMessage({
      defaultMessage: "Severe malaria",
      id: "nigeriaDailyOutpatientRegister.header.severeMalaria",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 70,
  },
  {
    field: "preReferralTreatment",
    headerName: formatMessage({
      defaultMessage: "Pre referral treatment",
      id: "nigeriaDailyOutpatientRegister.header.preReferralTreatment",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 105,
  },
  {
    field: "tbClinicallyScreened",
    headerName: formatMessage({
      defaultMessage: "TB clinically screened",
      id: "nigeriaDailyOutpatientRegister.header.tbClinicallyScreened",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 85,
  },
  {
    field: "tbClinicalScreeningForm",
    headerName: formatMessage({
      defaultMessage: "TB clinical screening form",
      id: "nigeriaDailyOutpatientRegister.header.tbClinicalScreeningForm",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 85,
  },
  {
    field: "tbReferred",
    headerName: formatMessage({
      defaultMessage: "TB referred",
      id: "nigeriaDailyOutpatientRegister.header.tbReferred",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 75,
  },
  {
    field: "hepatitisB",
    headerName: formatMessage({
      defaultMessage: "Hepatitis B",
      id: "nigeriaDailyOutpatientRegister.header.hepatitisB",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "hepatitisC",
    headerName: formatMessage({
      defaultMessage: "Hepatitis C",
      id: "nigeriaDailyOutpatientRegister.header.hepatitisC",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 90,
  },
  {
    field: "gbvCaseSeen",
    headerName: formatMessage({
      defaultMessage: "GBV case seen",
      id: "nigeriaDailyOutpatientRegister.header.gbvCaseSeen",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 125,
  },
  {
    field: "postGBVCareReceived",
    headerName: formatMessage({
      defaultMessage: "Post GBV care received",
      id: "nigeriaDailyOutpatientRegister.header.postGBVCareReceived",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 80,
  },
  {
    field: "gbvCaseReferred",
    headerName: formatMessage({
      defaultMessage: "GBV case referred",
      id: "nigeriaDailyOutpatientRegister.header.gbvCaseReferred",
    }),
    verticalAlignContents: "top",
    alignContents: "left",
    width: 80,
  },
];
